import {Injectable} from '@angular/core';
import {Question} from '../models/question.model';
import {Result} from '../models/result.model';

@Injectable({
  providedIn: 'root'
})
export class DataService {
  private documentId$: string;
  private questions$: Question[];
  private result$: Result;
  private qaId$: string;
  private domain$: string;
  private userId$: string;
  private libraryId$: string;
  private documentClassIdLog$: string;
  private quizSheetName$: string;
  private passMessage$: string;
  private failMessage$: string;

  constructor() {
  }

  set domain(value: string) {
    this.domain$ = value;
  }

  get domain(): string {
    return this.domain$;
  }

  set documentId(value: string) {
    this.documentId$ = value;
  }

  get documentId(): string {
    return this.documentId$;
  }

  set qaId(value: string) {
    this.qaId$ = value;
  }

  get qaId(): string {
    return this.qaId$;
  }

  set questions(value: Question[]) {
    this.questions$ = value;
  }

  get questions(): Question[] {
    return this.questions$;
  }

  set result(value: Result) {
    this.result$ = value;
  }

  get result(): Result {
    return this.result$;
  }

  set userId(value: string) {
    this.userId$ = value;
  }

  get userId(): string {
    return this.userId$;
  }

  set libraryId(value: string) {
    this.libraryId$ = value;
  }

  get libraryId(): string {
    return this.libraryId$;
  }

  set documentClassIdLog(value: string) {
    this.documentClassIdLog$ = value;
  }

  get documentClassIdLog(): string {
    return this.documentClassIdLog$;
  }

  set quizSheetName(value: string) {
    this.quizSheetName$ = value;
  }

  get quizSheetName(): string {
    return this.quizSheetName$;
  }

  set passMessage(value: string) {
    this.passMessage$ = value;
  }

  get passMessage(): string {
    return this.passMessage$;
  }

  set failMessage(value: string) {
    this.failMessage$ = value;
  }

  get failMessage(): string {
    return this.failMessage$;
  }
}
